import { Col, Container, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { AccountSettings } from "../../components/AccountSettings";
import { Bar } from "../../components/Bar";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { Button } from "../../components/Button";
import { Sidemenu } from "../../components/Sidemenu";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";

export const AccountSettingsPage = () => {
	return (
		<>
			<Bar fullWidth>
				<Link to="/">
					<Button bg={false} small icon={ArrowIcon}>
						Back
					</Button>
				</Link>
				<Breadcrumbs />
			</Bar>
			<Container>
				<Row>
					<Col sm={12} lg={2}>
						<Sidemenu
							items={[
								{ name: "Personal data", path: "/profile/details" },
								{ name: "My documents", path: "/profile/documents" },
								{ name: "My units", path: "/profile/units" },
								{ name: "Account settings", path: "/profile/settings" },
							]}
						/>
					</Col>
					<Col sm={12} lg={10}>
						<AccountSettings />
					</Col>
				</Row>
			</Container>
		</>
	);
};
